module.exports = __webpack_public_path__ + "img/business-license.1faa5053.png";